// @flow
import EventList from 'components/event/EventList';
import { connect } from 'react-redux';
import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/event/EventList';
import { fetchPageList } from 'actions/pageActions';
import { fetchEvents } from 'actions/eventsActions';

export default connect(
  (state: StateType): StateProps => ({
    clubID: state.settingsState.club_id,
    organization: state.settingsState.title,
    competitionsEquipes: state.settingsState.competitionsEquipes,
    ligue: state.settingsState.ligue,
    events: state.eventsState.events,
    eventsStatus: state.eventsState.status,
    banniere: state.settingsState.banniere,
    placeholder: state.settingsState.placeholder,
    title: state.pageListState.title,
    featured_media: state.pageListState.featured_media,
    rencontresLive: state.rencontreLiveState.rencontres ? Object.keys(state.rencontreLiveState.rencontres).length : 0,
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchEvents: (
      from: Date,
      to: Date,
      clubID: string,
      competitions: number[]
    ) => dispatch(fetchEvents(from, to, clubID, competitions)),
    fetchPageList: (slug: string) => dispatch(fetchPageList(slug)),
  })
)(EventList);
